import React from 'react';
import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid';

function SectionHeader({ title, subtitle, mt, size, align, actions }) {
  return (
      <Grid sx={{p: 2}} container mt={mt}>
        <Grid item xs={actions ? 8 : 12} >
          <Box mb={0} >
            <Typography align={align} variant={size || "h4"} gutterBottom>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body1" color="textSecondary">
                {subtitle}
              </Typography>
            )}
          </Box>
        </Grid>
        {actions && 
          <Grid item xs={4} >
            <Box display='flex' justifyContent="flex-end">
              {actions}
            </Box>
          </Grid>
        }
      </Grid>
  );
}

export default SectionHeader;
